import { lazy } from "react";
import url from "src/config/search.json";

const KmlToPage = lazy(() => import("src/pages/conversion/kml-to"));
const ShapefileToPage = lazy(() => import("src/pages/conversion/shapefile-to"));
const GeojsonToPage = lazy(() => import("src/pages/conversion/geojson-to"));
const CadToPage = lazy(() => import("src/pages/conversion/cad-to"));
const FgdbToPage = lazy(() => import("src/pages/conversion/fgdb-to"));
const PdfToPage = lazy(() => import("src/pages/conversion/pdf-to"));
const ConvToPage = lazy(() => import("src/pages/conversion/Converter-to"));

const keys = Object.keys(url.services);
const currentkey = keys[1];
export const conversionRoutes = [
  {
    path: currentkey,

    children: [
      { path: url.services.Conversion[0].url, element: <KmlToPage /> },
      { path: url.services.Conversion[1].url, element: <ShapefileToPage /> },
      { path: url.services.Conversion[2].url, element: <GeojsonToPage /> },
      { path: url.services.Conversion[3].url, element: <CadToPage /> },
      { path: url.services.Conversion[4].url, element: <FgdbToPage /> },
      { path: url.services.Conversion[5].url, element: <PdfToPage /> },
      { path: url.services.Conversion[6].url, element: <ConvToPage /> },
    ],
  },
];
